export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5472.49ce70bf.jpg";